var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14.667,
    viewBox: "0 0 16 14.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9812",
    "data-name": "Trac\\xE9 9812",
    d: "M12.333,22.667H8.328a.34.34,0,0,1-.155-.038L6.21,21.6a2.338,2.338,0,0,0-1.083-.267H3.667A3.671,3.671,0,0,0,0,25v7.333A3.671,3.671,0,0,0,3.667,36h8.667A3.671,3.671,0,0,0,16,32.334v-6A3.671,3.671,0,0,0,12.333,22.667ZM14,32.334A1.667,1.667,0,0,1,12.333,34H3.667A1.667,1.667,0,0,1,2,32.334V25.979H13.96a1.644,1.644,0,0,1,.04.355Z",
    transform: "translate(0 -21.334)",
    fill: "#b5b5b5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubFile);
export default __webpack_public_path__ + "static/media/SubFile.a6deaff9e2afe6d78b17c914a69f7308.svg";
export { ForwardRef as ReactComponent };